<template lang='pug'>
  div.popover
    el-popover.po(
      ref="po"
      :visible-arrow='false'
      placement="left-end"
      offset='10'
      :width="width||400"
      :height="height||300"
      @show="show"
      @hide="hide"
      :trigger="trigger || 'click'")
        div(v-if="popperShow" @click='autoClose && confirm')
          div.po-content
            slot
          div.btn-confirm(v-if='showConfirm')
            el-button(type="primary" size="mini" @click='confirm') {{btnText || '确认'}}

    <a class="po-num" v-if='text' v-popover:po>{{text}}</a>
    <div class="po-num" v-else v-popover:po style="width:100%">
      slot(name='trigger')
    </div>
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  props: {
    text: String,
    width: Number,
    height: Number,
    showConfirm: {
      type: Boolean
    },
    autoClose: Boolean,
    trigger: String,
    btnText: String
  },
  data: function() {
    return {
      popperShow: false
    };
  },
  methods: {
    show: function() {
      this.$emit('beforeShow');
      return this.popperShow = true;
    },
    hide: function() {
      return this.popperShow = false;
    },
    close: function() {
      return this.$refs.po.doClose();
    },
    confirm: function() {
      this.$emit('confirm');
      return this.close();
    }
  }
};
</script>

